import React, { useEffect, useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { apiInchat } from 'api'
import { CardInfoUserChannel } from 'components/Sidemenu/SideMenuInChat/components'
import { getStaticImage } from 'utils/statics'
import ModalDelete from 'components/ModalDelete'
import { useHistory } from 'react-router-dom'
import { clearReduxExitChannel } from '../utils'

const Information = (props) => {
  const { conversation, conversationAction, dispatch, toggleOpen, tabs, isChannel } = props
  const [createdBy, setCreatedBy] = useState({})
  const [modalExitChannel, setModalExitChannel] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [messageError, setMessageError] = useState('')
  const history = useHistory()

  useEffect(() => {
    const creator = conversation.usersInfo.find(user => user._id === conversation.createdBy)
    if(creator){
      setCreatedBy(creator)
    }else{
      getOperator(conversation.createdBy)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getOperator = (id) => {
    apiInchat.getOperatorById(id).then(({ data: { data } }) => {
      setCreatedBy({ ...data, id: data._id })
    })
  }

  const exitChannel = async () => {
    setModalExitChannel(!modalExitChannel)
  }

  const exitChannelModal = async () => {
    try {
      setMessageError('')
      setIsSubmitting(true)
      await conversationAction({
        type: 'leave',
        conversationId: conversation._id,
        conversationType: conversation.type
      })
      exitChannel()
      clearReduxExitChannel(dispatch, conversation, history, toggleOpen, tabs)
    } catch (error) {
      setMessageError(lang('dashboard_error_channel_exit'))
    }
    setIsSubmitting(false)
  }

  return (
    <div className='inchat-info-container'>
      <div className='inchat-info-container__info'>
        {isChannel &&
          <div>
            <span className='inchat-info-container__title'>{lang('dashboard_description')}</span>
            <p className='inchat-info-container__description'>{conversation.description}</p>
          </div>
        }
        <div>
          <span className='inchat-info-container__title'>{lang('dashboard_created-by')}</span>
          {createdBy._id && <CardInfoUserChannel user={createdBy} inInfo className={'inchat-info-container__info--cursor'}/>}
        </div>
      </div>

      {isChannel &&
        <button
          className='inchat-info-container__button'
          onClick={exitChannel}
        >
          <img
            src={getStaticImage('/icons/orange-brand/icon-exit-red.svg')}
            alt={''}
            onError={event => {
              event.target.className = 'not-channel-icon'
              event.onerror = null
            }}
          />
          <span>{lang('dashboard_exit_channel')}</span>
        </button>
      }
      <ModalDelete
        isOpen={modalExitChannel}
        toggle={() => {
          setModalExitChannel(!modalExitChannel)
          setMessageError('')
        }}
        header={lang('dashboard_exit_channel')}
        text1={lang('dashboard_exit_channel_questions')}
        text2={lang('dashboard_exit_channel_legend')}
        event={() => exitChannelModal()}
        isSubmitting={isSubmitting}
        textBtn1={lang('dashboard_leave')}
        errorMessage={messageError}
      />
    </div>
  )
}

export default Information